import React from "react";
import get from "lodash.get";
import CurrencyTag from "./CurrencyTag";

const DEFAULT_CURRENCY = "EUR";

interface ITotalCostTag {
  costs?: Array<{
    amount: {
      currency: string;
      value: number;
      rate: number;
    };
    calculatedExchange: number;
  }>;
  currency?: string;
}

export const totalCostSum = (costs = []) =>
  costs.reduce((acc, cur) => {
    if (cur.isUnchecked) return acc;
    const convertedValue =
      get(cur, ["amount", "value"], 0) *
      (cur.calculatedExchange || get(cur, ["amount", "rate"]) || 1);

    return convertedValue + acc;
  }, 0);

// takes costs array that has calculatedExchange.
const TotalCostTag = ({
  costs = [],
  currency = DEFAULT_CURRENCY
}: ITotalCostTag) => {
  const totalCost = totalCostSum(costs);

  return <CurrencyTag value={totalCost} currency={currency} />;
};

export default TotalCostTag;
